export { default, BALogoSmallOnPhone } from './BALogo';



// WEBPACK FOOTER //
// ./src/components/BALogo/index.js